module.exports = {"210727001":"义州街道","210727002":"城关街道","210727101":"刘龙台镇","210727102":"七里河镇","210727103":"大榆树堡镇","210727104":"稍户营子镇","210727105":"九道岭镇","210727106":"高台子镇","210727108":"瓦子峪镇","210727109":"头台镇","210727110":"前杨镇","210727111":"张家堡镇","210727112":"头道河镇","210727113":"留龙沟镇","210727114":"聚粮屯镇","210727203":"地藏寺满族乡","210727205":"大定堡满族乡","210727207":"白庙子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210727.json
// module id = 643
// module chunks = 0